import React, { useCallback } from 'react';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import locationLabelText from '@tmap/mmm-core/locationLabelText'
import { toKey } from '@tmap/mmm-core/entityKey';
import { useDispatch } from 'react-redux';
import { updateUserProfile } from '../../actions/userProfile';
import { addUserFavorite } from '../../actions/user';

const WhereYouLiveQuestion = ({ community, setAnswered }) => {
  const dispatch = useDispatch();
  const locationText = locationLabelText(community.locationText, community.regionText);

  const handleAnswerClick = useCallback((handleAnswer) => () => {
    handleAnswer();
    setAnswered(true);
  }, [setAnswered]);
  const yesAction = useCallback(() => dispatch(updateUserProfile({
    personalInfo: {
      city: community.locationText,
      state: community.locationGeo.state_abbreviation,
    }
  })), [community, updateUserProfile]);
  const movingAction = useCallback(() => {
    const entityKey = toKey(community._type, community._id);
    dispatch(addUserFavorite(entityKey));
  }, [community]);
  const noAction = useCallback(() => { }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color='textPrimary' sx={{ fontWeight: 600 }}>Do you currently live in or near {locationText}?</Typography>
      </Grid>
      <Grid item>
        <Button variant='contained' color='primary' onClick={handleAnswerClick(yesAction)}>
          Yes, I'm a current resident
        </Button>
      </Grid>
      <Grid item>
        <Button variant='contained' color='primary' onClick={handleAnswerClick(yesAction)}>
          Yes, I live near {community.locationText}
        </Button>
      </Grid>
      <Grid item>
        <Button variant='contained' color='primary' onClick={handleAnswerClick(movingAction)}>
          I'm considering moving
        </Button>
      </Grid>
      <Grid item>
        <Button variant='contained' color='primary' onClick={handleAnswerClick(noAction)}>
          No, I'm just browsing
        </Button>
      </Grid>
    </Grid>
  )
}

export default WhereYouLiveQuestion;